const fmt = (k, v) => {
  if (!v) return k === "notified_at" ? "Not sent" : "—";
  if (k.includes("_at")) return new Date(v).toLocaleString();
  return String(v);
};

const EmptyRow = ({ cols, text, testId }) => (
  <tr><td colSpan={cols + 1} className="px-5 py-8 text-center text-muted" data-testid={testId}>{text}</td></tr>
);

const TableBody = ({ loading, rows, cols, selectable, selected, onToggle }) => {
  if (loading) return <EmptyRow cols={cols.length} text="Loading…" />;
  if (rows.length === 0) return <EmptyRow cols={cols.length} text="Nothing here yet." testId="admin-empty" />;
  return rows.map((r) => (
    <tr key={r.id} className="border-b border-line/50 align-top last:border-0 hover:bg-panel2/60" data-testid="admin-row">
      {selectable && (
        <td className="px-5 py-3">
          <input type="checkbox" className="accent-blue" checked={selected.includes(r.id)} onChange={(e) => onToggle(r.id, e.target.checked)} data-testid="admin-select-row" />
        </td>
      )}
      {cols.map(([k]) => <td key={k} className="max-w-xs whitespace-pre-wrap px-5 py-3 text-body">{fmt(k, r[k])}</td>)}
    </tr>
  ));
};

export const DataTable = ({ tab, cols, rows, loading, selectable, selected, onSelectAll, onToggle }) => (
  <div className="card mt-8 overflow-hidden p-0" data-testid="admin-table-card">
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm" data-testid={`admin-table-${tab}`}>
        <thead className="border-b border-line text-xs uppercase tracking-[0.15em] text-muted">
          <tr>
            {selectable && (
              <th className="px-5 py-3">
                <input type="checkbox" className="accent-blue" checked={rows.length > 0 && selected.length === rows.length} onChange={(e) => onSelectAll(e.target.checked)} data-testid="admin-select-all" />
              </th>
            )}
            {cols.map(([k, label]) => <th key={k} className="px-5 py-3 font-medium">{label}</th>)}
          </tr>
        </thead>
        <tbody>
          <TableBody loading={loading} rows={rows} cols={cols} selectable={selectable} selected={selected} onToggle={onToggle} />
        </tbody>
      </table>
    </div>
  </div>
);
